module.exports = __webpack_public_path__ + "img/droneblocks-crazyflie.9e39e4c3.png";